import React from 'react';
import { DEFAULT_COLORS } from '@/components/widget/visualizations/TreeMap';
import { useTheme } from '@/components/widget/Layout/ThemeProvider';
import ColorPalletMenu from '@/components/Editor/Form/fields/ColorPalletMenu';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const WidgetEditFormTreeMap = _ref => {
  let {
    config,
    onChange
  } = _ref;
  const {
    colorPallet: defaultColorPallet = DEFAULT_COLORS
  } = useTheme();
  const {
    colorPallet = defaultColorPallet
  } = config;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(ColorPalletMenu, {
      colors: colorPallet,
      palletColorOverrides: config.palletColorOverrides,
      onOverridePalletColors: (name, colors) => onChange('palletColorOverrides', {
        [name]: colors
      }),
      onChange: colorPallet => onChange('', {
        colorPallet
      })
    })
  });
};

export default WidgetEditFormTreeMap;